export default "__VITE_ASSET__CQ3swy02__"